import React from 'react';
import './SingleResult.css';

const SingleResult = ({ options }) => {
    if (!Array.isArray(options)) {
        console.error("SingleResult expected 'options' to be an array but received:", options);
        return <div>Данные отсутствуют</div>;
    }

    return (
        <div className='singleResult__options'>
            {options.map((option) => (
                <div className={`testResult__option`} key={option.id}>
                    {/* <div className={`singleResult__radio ${option.weight > 0 && option.selected ? 'singleResult__radio_right' : option.selected ? 'singleResult__radio_wrong' : ''}`}>
                        {option.selected && <div className='singleResult__selection' />}
                    </div> */}
                    <div className={`${option.weight > 0 ? 'singleResult__option_true' : 'singleResult__option_false'}`}>{option.text}</div>
                    <div className={option.selected === true ? option.weight > 0 ? 'singleResult__answer_true' : 'singleResult__answer_false' : ''} />
                    {option.selected === true && <div className='singleResult__option_answered'>Отвечено</div>}
                </div>
            ))}
        </div>
    );
};

export default SingleResult;
